export default __webpack_public_path__ + "static/media/tier2.2d6a063e.png";